@let isInGroup = data.groupIndex !== null;

@if (store.isEditPanel()) {
	@let inEditMode = isItemInEditMode() && !isReadOnly;

	<sim-assessable-item
		[isInArchive]="isInArchive"
		[hideExpandButton]="hideExpandButton"
		[dragHandleTemplate]="data.dragHandle"
		[item]="data.item"
		[inEditMode]="inEditMode"
		[expanded]="isItemExpanded()"
		[mode]="AssessablePanelMode.Edit"
		[indexInGroup]="data.index"
		[groupIndex]="data.groupIndex"
		[canEnterEditMode]="contextService.form.valid && !isReadOnly"
		[disabled]="store.isDisabled()"
		[scoreTemplate]="scoreTemplateEditMode"
		[menuContentTemplate]="menuContentTemplate"
		[multipleChoiceItemTemplate]="multipleChoiceItemTemplate"
		[singleChoiceItemTemplate]="singleChoiceItemTemplate"
		[yesNoItemTemplate]="yesNoItemTemplate"
		[ratingItemTemplate]="ratingItemTemplate"
		[freeAnswerItemTemplate]="freeAnswerItemTemplate"
		[middleAdditionalContentTemplate]="middleAdditionalContentTemplate"
		[scenarioRecording]="contextService.scenarioRecording"
		(onExpand)="store.handleItemExpand(data.item.assessableItemId)"
		(onCollapse)="store.handleItemCollapse()"
		(onTimestampClicked)="onTimestampClicked.emit()"
		(onChangeChecklistItemType)="contextService.handleItemTypeChange(data.item, $event)"
	>
		<ng-template #middleAdditionalContentTemplate>
			<div class="additionalTextInputsWrapper">
				@if (inEditMode) {
					<div class="textEditMode" appStopPropagation [stopPKeyDown]="true" [@zoomInOnEnter]>
						<mat-form-field color="accent" class="full-width-form" subscriptSizing="dynamic">
							<mat-label>{{ T.ASSESSMENT_ITEM_PROCEDURE | translate }}</mat-label>
							<sim-rich-text-editor-control
								[placeholder]="T.ASSESSMENT_ITEM_PROCEDURE | translate"
								[formControl]="itemControl.controls.procedure"
							/>
						</mat-form-field>
					</div>
					<div class="textEditMode" appStopPropagation [stopPKeyDown]="true" [@zoomInOnEnter]>
						<mat-form-field color="accent" class="full-width-form" subscriptSizing="dynamic">
							<mat-label>{{ T.ASSESSMENT_ITEM_HINTS_AND_REASONING | translate }}</mat-label>
							<sim-rich-text-editor-control
								[placeholder]="T.ASSESSMENT_ITEM_HINTS_AND_REASONING | translate"
								[formControl]="itemControl.controls.hintsAndReasoning"
							/>
						</mat-form-field>
					</div>
				} @else {
					@if (itemControl.controls.procedure.value) {
						<div class="textNonEditMode showDotsOnOverflow" [class.nonEditMode]="false" [@zoomInOnEnter]>
							<label>{{ T.ASSESSMENT_ITEM_PROCEDURE | translate }}</label>
							<sim-rich-text-editor-view [content]="itemControl.controls.procedure.value" />
						</div>
					}
					@if (itemControl.controls.hintsAndReasoning.value) {
						<div class="textNonEditMode showDotsOnOverflow" [class.nonEditMode]="false" [@zoomInOnEnter]>
							<label>{{ T.ASSESSMENT_ITEM_HINTS_AND_REASONING | translate }}</label>
							<sim-rich-text-editor-view [content]="itemControl.controls.hintsAndReasoning.value" />
						</div>
					}
				}
			</div>
			@if (isReadOnly && data.item.competenceCategoryDistribution.length) {
				<sim-competence-category-answer class="editItemCompetenceCategoryPanel" [assessmentItemId]="data.item.assessableItemId" />
			} @else if (data.item.competenceCategoryDistribution.length) {
				<sim-competence-category-edit class="editItemCompetenceCategoryPanel" [assessmentItemId]="data.item.assessableItemId" />
			}
		</ng-template>

		<ng-template #scoreTemplateEditMode>
			<!-- KO Checkbox -->
			<mat-checkbox
				class="koQuestionCheckbox"
				[matTooltip]="T.ASSESSMENT_ITEM_KO_HINT | translate"
				matTooltipClass="accent"
				[checked]="itemControl.controls.isKnockoutQuestion.value"
				(change)="itemControl.controls.isKnockoutQuestion.setValue($event.checked)"
				[disabled]="isReadOnly"
				[indeterminate]="false"
				labelPosition="before"
				appStopPropagation
			>
				{{ T.ASSESSMENT_ITEM_KO_ITEM | translate }}
			</mat-checkbox>

			<!-- Score -->
			@if (!hideScore) {
				<mat-divider [vertical]="true" />

				<div class="scoreInHeader">
					<div class="reachedScore">0</div>
					/
					<div class="maxScore">
						{{ getItemMaxScore(data.item) }}
					</div>
				</div>

				<mat-divider [vertical]="true" />
			}
		</ng-template>
	</sim-assessable-item>
} @else {
	@let hasMiddleAdditionalContent = data.item.competenceCategoryDistribution.length && !hideExpansionArea;
	<sim-assessable-answer-item
		[isInArchive]="isInArchive"
		[compactLayout]="compactLayout"
		[hideExpandButton]="hideExpandButton"
		[hideExpansionArea]="hideExpansionArea"
		[item]="data.item"
		[expanded]="isItemExpanded()"
		[mode]="store.mode()"
		[indexInGroup]="data.index"
		[groupIndex]="data.groupIndex"
		[disabled]="store.isDisabled()"
		[scoreTemplate]="scoreTemplateAnswerMode"
		[multipleChoiceItemTemplate]="multipleChoiceItemTemplate"
		[singleChoiceItemTemplate]="singleChoiceItemTemplate"
		[yesNoItemTemplate]="yesNoItemTemplate"
		[ratingItemTemplate]="ratingItemTemplate"
		[freeAnswerItemTemplate]="freeAnswerItemTemplate"
		[hasMiddleAdditionalContent]="hasMiddleAdditionalContent"
		[middleAdditionalContentTemplate]="middleAdditionalContentTemplate"
		[scenarioRecording]="contextService.scenarioRecording"
		[isHintsDialogEnabled]="isHintsDialogEnabled() && (!!data.item.procedure || !!data.item.hintsAndReasoning)"
		(onExpand)="store.handleItemExpand(data.item.assessableItemId)"
		(onCollapse)="store.handleItemCollapse()"
		(onTimestampClicked)="onTimestampClicked.emit()"
		(onOpenHintsDialog)="openHintsProcedureAndReasoningDialog()"
	>
		<ng-template #middleAdditionalContentTemplate>
			@if (hasMiddleAdditionalContent) {
				<sim-competence-category-answer [assessmentItemId]="data.item.assessableItemId" />
			}
		</ng-template>

		<ng-template #scoreTemplateAnswerMode>
			@if (!hideScore) {
				<sim-item-score
					[score]="getItemScore(data.item, answerItemControl.value)"
					[dimmed]="getItemScore(data.item, answerItemControl.value) === '-'"
					[isKnockout]="SimConfigurationService.settings.showKoCriteriaForExaminer && data.item.isKnockoutQuestion"
				/>
			}
		</ng-template>
	</sim-assessable-answer-item>
}

<ng-template #menuContentTemplate>
	@if (data.item.type === ChecklistItemType.ThreeStarOption) {
		<button
			mat-menu-item
			class="menueButtonWithFAIcon accent"
			(click)="contextService.changeRatingItemIcons(data.item)"
			[matTooltip]="T.ASSESSMENT_CHANGE_RATING_ITEM_ICONS_DIALOG_TITLE | translate"
			matTooltipClass="accent"
			[disabled]="!contextService.form.valid"
		>
			<mat-icon class="smaller" fontSet="fad" fontIcon="fa-icons" inline />
			<span>{{ T.ASSESSMENT_CHANGE_RATING_ITEM_ICONS_DIALOG_TITLE | translate }}</span>
		</button>
	}

	<button
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		(click)="
			isInGroup
				? contextService.shiftGroupedItem('up', data.groupIndex, data.index)
				: contextService.shiftUngroupedItem('up', data.index)
		"
		[matTooltip]="T.ASSESSABLE_ITEM_MOVE_UP | translate"
		matTooltipClass="accent"
		[disabled]="data.index === 0 || !contextService.form.valid"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-arrow-up" inline />
		<span>{{ T.ASSESSABLE_ITEM_MOVE_UP | translate }}</span>
	</button>

	<button
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		(click)="
			isInGroup
				? contextService.shiftGroupedItem('down', data.groupIndex, data.index)
				: contextService.shiftUngroupedItem('down', data.index)
		"
		[matTooltip]="T.ASSESSABLE_ITEM_MOVE_DOWN | translate"
		matTooltipClass="accent"
		[disabled]="data.index === data.length - 1 || !contextService.form.valid"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-arrow-down" inline />
		<span>{{ T.ASSESSABLE_ITEM_MOVE_DOWN | translate }}</span>
	</button>

	<button
		*ngIf="isInGroup"
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		[disabled]="!contextService.form.valid"
		(click)="contextService.moveItemToOtherGroup(data.index, data.groupIndex)"
		[matTooltip]="T.ASSESSABLE_ITEM_MOVE_TO_OTHER_GROUP | translate"
		matTooltipClass="accent"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-layer-minus" inline />
		<span>{{ T.ASSESSABLE_ITEM_MOVE_TO_OTHER_GROUP | translate }}</span>
	</button>

	<button
		mat-menu-item
		class="menueButtonWithFAIcon warn"
		[disabled]="!contextService.form.valid && !isItemInEditMode()"
		(click)="contextService.removeItem(createRemoveItemEvent(data.index, data.groupIndex))"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-trash-alt" inline />
		<span>{{ T.ASSESSABLE_ITEM_REMOVE | translate }}</span>
	</button>
</ng-template>

<ng-template #multipleChoiceItemTemplate>
	<sim-multiple-choice-item
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode() && !isReadOnly"
		[item]="mapToChoiceItem(data.item)"
		[optionTemplate]="optionTemplate"
		[scoreTemplate]="scoreTemplate"
		[rightOfAddOptionTemplate]="rightOfAddOptionTemplate"
		(onAddOption)="contextService.addSelectableOption(itemControl, false)"
		(onRemoveOption)="contextService.removeSelectableOption(itemControl, $event)"
		(onUpdateAnswerMultipleChoice)="handleMultipleChoiceAnswerChanged($event)"
	>
		<ng-template #optionTemplate let-context>
			<mat-form-field color="accent" class="full-width-form">
				<mat-label>{{ T.SHARED_EXPANSION_OPTION_TEXT | translate }}</mat-label>
				<sim-rich-text-editor-control [formControl]="itemControl.controls.selectableOptions.at(context.i).controls.option" />
				<mat-error *ngIf="itemControl.controls.selectableOptions.at(context.i).controls.option.hasError('required')">{{
					T.SHARED_EXPANSION_OPTION_REQUIRED | translate
				}}</mat-error>
			</mat-form-field>
		</ng-template>

		<ng-template #scoreTemplate let-context>
			<sim-assessment-point-input
				*ngIf="!hideScore"
				[pointControl]="itemControl.controls.selectableOptions.at(context.i).controls.score"
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_OPTION | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[isActiveScore]="store.isEditPanel() ? true : answerItemControl.value.answer?.includes(context.i)"
				customWidth="128px"
			/>
		</ng-template>

		<ng-template #rightOfAddOptionTemplate>
			<mat-checkbox
				*ngIf="isItemInEditMode()"
				[disabled]="isReadOnly"
				class="scoreCheckbox"
				[(ngModel)]="data.item.isScoreBoundedByZero"
				[indeterminate]="false"
				labelPosition="before"
			>
				{{ T.ASSESSMENT_LOWEST_POSSIBLE_SCORE | translate }}
			</mat-checkbox>
		</ng-template>
	</sim-multiple-choice-item>
</ng-template>

<ng-template #singleChoiceItemTemplate>
	<sim-single-choice-item
		[item]="mapToChoiceItem(data.item)"
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode() && !isReadOnly"
		[optionTemplate]="optionTemplate"
		[scoreTemplate]="scoreTemplate"
		(onAddOption)="contextService.addSelectableOption(itemControl)"
		(onRemoveOption)="contextService.removeSelectableOption(itemControl, $event)"
		(onUpdateAnswerSimple)="handleAnswerChanged($event)"
	>
		<ng-template #optionTemplate let-context>
			<mat-form-field color="accent" class="full-width-form">
				<mat-label>{{ T.SHARED_EXPANSION_OPTION_TEXT | translate }}</mat-label>
				<sim-rich-text-editor-control [formControl]="itemControl.controls.selectableOptions.at(context.i).controls.option" />
				<mat-error *ngIf="itemControl.controls.selectableOptions.at(context.i).controls.option.hasError('required')">{{
					T.SHARED_EXPANSION_OPTION_REQUIRED | translate
				}}</mat-error>
			</mat-form-field>
		</ng-template>

		<ng-template #scoreTemplate let-context>
			<sim-assessment-point-input
				*ngIf="!hideScore"
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_OPTION | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[pointControl]="itemControl.controls.selectableOptions.at(context.i).controls.score"
				[isActiveScore]="store.isEditPanel() ? true : answerItemControl.value.answer === context.i"
				customWidth="128px"
			/>
		</ng-template>
	</sim-single-choice-item>
</ng-template>

<ng-template #yesNoItemTemplate>
	<sim-yes-no-item
		[answer]="answerItemControl.value.answer"
		[mode]="store.mode()"
		[disabled]="store.isDisabled()"
		[yesScoreTemplate]="yesScoreTemplate"
		[noScoreTemplate]="noScoreTemplate"
		(onUpdateAnswerSimple)="handleAnswerChanged($event)"
	>
		<ng-template #yesScoreTemplate>
			<sim-assessment-point-input
				*ngIf="!hideScore"
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_NO | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[pointControl]="itemControl.controls.yesNoScores.at(0)"
				[isActiveScore]="store.isEditPanel() ? true : answerItemControl.value.answer === false"
			/>
		</ng-template>

		<ng-template #noScoreTemplate>
			<sim-assessment-point-input
				*ngIf="!hideScore"
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_YES | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[pointControl]="itemControl.controls.yesNoScores.at(1)"
				[isActiveScore]="store.isEditPanel() ? true : answerItemControl.value.answer === true"
			/>
		</ng-template>
	</sim-yes-no-item>
</ng-template>

<ng-template #ratingItemTemplate>
	<sim-rating-item
		[class.compact]="compactLayout"
		[answer]="answerItemControl.value.answer"
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode() && !isReadOnly"
		[scoreTemplate]="scoreTemplate"
		[hideScore]="hideScore"
		[stars]="data.item.starScores.length"
		[starScores]="data.item.starScores"
		[iconSetId]="itemControl.controls.ratingItemIconSetId.value"
		(onAddStar)="contextService.addThreeStarOption(itemControl)"
		(onRemoveStar)="contextService.removeThreeStarOption(itemControl)"
		(onStarClick)="handleAnswerChanged($event)"
	>
		<ng-template #scoreTemplate let-context>
			<sim-assessment-point-input
				*ngIf="store.isEditPanel()"
				[pointControl]="itemControl.controls.starScores.at(context.i)"
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_OPTION | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[isActiveScore]="true"
				customWidth="128px"
			/>
		</ng-template>
	</sim-rating-item>
</ng-template>

<ng-template #freeAnswerItemTemplate>
	<sim-free-answer-item
		[hideScore]="hideScore"
		[mode]="store.mode()"
		[answer]="answerItemControl.value.answer"
		[freeTextPointsTemplate]="freeTextPointsTemplate"
		(onFreeTextAnswerChanged)="handleAnswerChanged($event)"
	>
		<ng-template #freeTextPointsTemplate>
			<sim-assessment-point-input
				[isActiveScore]="true"
				[inEditMode]="store.mode() === AssessablePanelMode.Answer"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_FREE_TEXT_REACHED | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[pointControl]="answerItemControl.controls.freeTextScore"
			/>

			<span>{{ T.ASSESSABLE_ITEM_POINT_SEPARATOR | translate }}</span>

			<sim-assessment-point-input
				[inEditMode]="isItemInEditMode() && !isReadOnly"
				[label]="T.ASSESSABLE_ITEM_POINT_VALUE_FREE_TEXT_MAX | translate"
				[placeholder]="T.ASSESSABLE_ITEM_POINT_PLACEHOLDER | translate"
				[pointControl]="itemControl.controls.freeTextMaxScore"
			/>
		</ng-template>
	</sim-free-answer-item>
</ng-template>
